module.exports = __webpack_public_path__ + "static/media/plus-green.dfb0296f.svg";